module.exports = __webpack_public_path__ + "static/media/album_cover.0de34803.jpeg";